/* ec-reveal.js — V2 scroll-reveal. GUVENLIK ILKELERI (11.07 kilit dersi):
   TEK YONLU (is-in eklenir, geri alinmaz — dongu imkansiz),
   kendi yazdigini dinlemez, JS yoksa icerik GORUNUR (gizleme yalniz html.ec-motion),
   reduced-motion'da hic gizlenmez (CSS guard),
   IO'ya KOR GUVEN YOK: viewport-ici elemanlar aninda gorunur (rect check),
   IO olmez/olmazsa pasif scroll-resize yedegi devreye girer. */
(function () {
  'use strict';
  if (window.__ecReveal) return; window.__ecReveal = 1;

  var pending = [];
  var fallbackOn = false;
  var io = null;

  function inView(el) {
    var r = el.getBoundingClientRect();
    return r.top < window.innerHeight * 0.92 && r.bottom > 0 && (r.width || r.height);
  }
  function show(el) { el.classList.add('is-in'); if (io) { try { io.unobserve(el); } catch (e) {} } }

  function ensureIO() {
    if (io || !window.IntersectionObserver) return io;
    io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) show(entries[i].target);
      }
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    return io;
  }

  function drain() {
    if (!pending.length) return;
    pending = pending.filter(function (el) {
      if (el.classList.contains('is-in')) return false;
      if (inView(el)) { show(el); return false; }
      return true;
    });
    if (!pending.length && fallbackOn) {
      window.removeEventListener('scroll', drain);
      window.removeEventListener('resize', drain);
      fallbackOn = false;
    }
  }
  function ensureFallback() {
    if (fallbackOn || !pending.length) return;
    fallbackOn = true;
    window.addEventListener('scroll', drain, { passive: true });
    window.addEventListener('resize', drain, { passive: true });
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var els = scope.querySelectorAll('[data-ec-reveal]:not(.is-in)');
    if (!els.length) return;
    ensureIO();
    els.forEach(function (el) {
      if (inView(el)) { show(el); return; }   /* ilk ekran: IO beklemeden, aninda */
      if (io) io.observe(el);
      pending.push(el);                        /* IO olsa da yedek liste tutulur */
    });
    ensureFallback();
  }

  function boot() { scan(document); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
